var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "details-view tab-warning",
      staticStyle: { height: "600px !important" }
    },
    [
      _c(
        "cargo-left-right-resize",
        {
          ref: "cargoLeftRightResize",
          staticStyle: { "min-height": "90%" },
          attrs: {
            "left-style": { "max-width": "190px" },
            "right-style": { overflow: "hidden" }
          }
        },
        [
          _c("template", { slot: "left" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                { staticStyle: { margin: "6px 0px 0px 10px" } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      cache: false,
                      "tag-name": "name",
                      "tag-value": "code",
                      clearable: false,
                      "filter-tag-names": ["name"],
                      "filter-type": "global",
                      "default-value": _vm.filter.type,
                      "static-options": _vm.selectedList
                    },
                    on: { parentCallBack: _vm.changeSelectType }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid", {
                    staticClass: "section",
                    attrs: {
                      "grid-options": _vm.leftGridOptions,
                      "row-data": _vm.leftRowData,
                      "show-side-bar": false,
                      "min-height": "100%",
                      "grid-style":
                        "min-width: 240px;width:100%;height:90%;min-height:496px"
                    },
                    on: {
                      gridReady: function(p) {
                        _vm.gridApi = p.api
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                { staticClass: "operations", staticStyle: { margin: "6px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.fetchData()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Refresh")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showDealBtn,
                          expression: "showDealBtn"
                        }
                      ],
                      attrs: { type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.onHandled()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Sop.ignoreMessage")))]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid", {
                    attrs: {
                      "config-module": "11005",
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData,
                      "grid-style": "width:100%;height:90%;min-height:496px"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _c(
        "div",
        {
          staticStyle: {
            "min-height": "30px",
            height: "100%",
            position: "relative"
          }
        },
        [
          _c(
            "div",
            { staticStyle: { position: "absolute", right: "5px" } },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "11005",
                  total: _vm.filter.total || 0,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.queryTodoItemList
                }
              })
            ],
            1
          )
        ]
      ),
      _vm.billPaymentDialog.visible
        ? _c("bill-payment-dialog", {
            attrs: {
              visible: _vm.billPaymentDialog.visible,
              title: _vm.billPaymentDialog.title,
              "bill-payment-uuid": _vm.billPaymentDialog.billPaymentUuid,
              "is-direct-payment": _vm.isDirectPayment,
              location: _vm.location,
              "append-to-body": true,
              "modal-append-to-body": true
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.billPaymentDialog, "visible", $event)
              },
              cancel: _vm.closeBillPaymentDialog
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }